import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PublicLayout from "./components/PublicLayout";
import LandingPage from "./pages/LandingPage";
import Login from "./components/Login";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import About from "./pages/About";
import HowToUse from "./pages/HowToUse";
import ContactUs from "./pages/ContactUs";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Dashboard from "./components/Dashboard";
import Users from "./pages/Users";
import Categories from "./pages/Categories";
import AddCategory from "./pages/AddCategory";
import EditCategory from "./pages/EditCategory";
import CommitteesOverview from "./pages/CommitteesOverview";
import Committees from "./pages/Committees";
import AddCommittee from "./pages/AddCommittee";
import EditCommittee from "./pages/EditCommittee";
import CommitteeDetail from "./pages/CommitteeDetail";
import Contacts from "./pages/Contacts";
import Notifications from "./pages/Notifications";
import PrivateRoute from "./utils/PrivateRoute";
import Layout from "./components/Layout";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PublicLayout />}>
          <Route index element={<LandingPage />} />
          <Route path="login" element={<Login />} />
          <Route path="admin" element={<Login />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="about" element={<About />} />
          <Route path="how-to-use" element={<HowToUse />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="blog" element={<Blog />} />
          <Route path="blog/:slug" element={<BlogPost />} />
        </Route>

        {/* Wrap all private routes inside Layout */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="categories" element={<Categories />} />
          <Route path="add-category" element={<AddCategory />} />
          <Route path="edit-category/:id" element={<EditCategory />} />
          <Route path="committees" element={<CommitteesOverview />} />
          <Route path="committees/auction" element={<Committees />} />
          <Route path="add-committee" element={<AddCommittee />} />
          <Route path="edit-committee/:id" element={<EditCommittee />} />
          <Route path="committee/:id" element={<CommitteeDetail />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="notifications" element={<Notifications />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
